import { useEffect } from 'react'
import { useResizeDetector } from 'react-resize-detector'

import { GraphType, GraphDefaultProps, GraphRender } from '../common'
import { usePieGraphOption, PieGraphOptions } from './container/options'
import { usePieGraphModel } from './container/model'
import { usePieGraphRenderOption } from './container/render'
import { usePieGraphEvents } from './container/event'

import ReactEChartsCore from 'echarts-for-react/lib/core'
import * as echarts from 'echarts/core'
import { PieChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'

import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from 'echarts/components'

import { Box } from '@mui/material'

echarts.use([
  TooltipComponent,
  GridComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
])

const PieGraph = <T,>({
  dashBoard,
  targetList,
  dataList,
  conditions,
  onChangeCondition,
  itemData,
  isResizing,
  graphRef,
  setCsv
}: GraphDefaultProps<T>) => {
  const { options, filterText } = itemData
  const { width, height, ref } = useResizeDetector()

  const graphOption = usePieGraphOption({ dashBoard, options, targetList })
  const graphData = usePieGraphModel({ dashBoard, dataList, conditions, filterText, graphOption })
  const renderOption = usePieGraphRenderOption({ graphOption, graphData })
	const events = usePieGraphEvents({ graphOption, onChangeCondition })

  useEffect(
    () => setCsv({ builder: () => graphData?.csvBuilder() }),
    [graphData, setCsv]
  )
  const { axisDef, valueDef } = graphOption
  return (
    <Box ref={ref} width="100%" height="100%">
      <GraphRender<T>
        dashBoard={dashBoard}
        keys={[axisDef?.key, valueDef?.key]}
        invalid={!graphData || isResizing || ((height ?? 0) <= 10)}
      >
        {(width && height) ? (
          <ReactEChartsCore
            ref={graphRef}
            echarts={echarts}
            notMerge={true}
            onEvents={events}
            option={renderOption}
            opts={{ renderer: 'canvas' }}
            style={{ width, height }}
            theme="insite"
          />
        ) : <></>}
      </GraphRender>
    </Box>
  )
}

export const PieGraphFactory: GraphType = {
  title: '円グラフ',
  options: PieGraphOptions,
  element: <T,>(props: GraphDefaultProps<T>) => <PieGraph<T> {...props} />,
}
